/**
 * MSC Storage Compliance Types
 */

export type ConsentCategory = 'cookiesan-DjkpJyaY' | (string & Record<string, never>);

export const STORAGE_TYPES = {
  LOCAL: 'local',
  SESSION: 'session',
  COOKIES: 'cookies',
} as const;

export type StorageType = (typeof STORAGE_TYPES)[keyof typeof STORAGE_TYPES];

export interface StorageKeyConfigItem {
  readonly key: string;
  readonly pattern: string;
  readonly category: ConsentCategory;
  readonly storage: StorageType;
  readonly ttlDays: number;
  readonly vendors: string[];
  readonly isPrefix: boolean;
}

export type StorageComplianceKeyConfig = readonly StorageKeyConfigItem[];
export type MscKeyConfig = StorageKeyConfigItem;

export interface MscSetOptions {
  readonly enforceConsent?: boolean;
  readonly ttlDays?: number;
}

export interface StorageEnvelope<T = unknown> {
  readonly value: T;
  readonly _exp: number;
  readonly _ts: number;
}
